import React, { useEffect, useContext } from "react";
import "../Components/Orders/Orders.css";
import { techappContext } from "../../Api/techappReq";
import OrderCard from "../Components/order_card";
import Empty from "../Components/empty";
import { Skeleton } from "antd";

const AvailableOrders = () => {
  const { getOrder, orders, loading } = useContext(techappContext);

  const skeletonItems = [1, 1, 1, 1];

  useEffect(() => {
    getOrder("available");
  }, []);

  return (
    <div className="tech-app-orders-container">
      {/* list view */}
      {!loading &&
        orders?.available?.length > 0 &&
        orders?.available?.map((order, index) => (
          <OrderCard
            key={index}
            order={order}
            index={index}
            type={order.status_name}
            labelColor={"#1e5279"}
          />
        ))}
      {/* empty list */}
      {!loading && orders?.available?.length === 0 && (
        <Empty title={"سفارشی یافت نشد."} />
      )}
      {/* skeleton loading */}
      {loading &&
        skeletonItems.map((item, index) => (
          <Skeleton.Button
            style={{
              width: "100%",
              height: "130px",
              marginBottom: "10px",
              borderRadius: "8px",
            }}
            shape={"square"}
            active
            key={index}
          />
        ))}
    </div>
  );
};
export default AvailableOrders;
